var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 173,
    viewBox: "0 0 172 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 1.07124,
    y: 86.1738,
    width: 87,
    height: 74,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.07124,
    y: 86.1738,
    width: 87,
    height: 74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0375 159.172C30.92 152.808 22.2478 144.394 15.5802 134.472C8.91261 124.549 4.39765 113.339 2.32647 101.563L86.5518 86.7347L41.0375 159.172Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0375 159.172C30.92 152.808 22.2478 144.394 15.5802 134.472C8.91261 124.549 4.39765 113.339 2.32647 101.563L86.5518 86.7347L41.0375 159.172Z",
    fill: "#29C18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0375 159.172C30.92 152.808 22.2478 144.394 15.5802 134.472C8.91261 124.549 4.39765 113.339 2.32647 101.563L86.5518 86.7347L41.0375 159.172Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_5_7287)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 40.0712,
    y: 86.1738,
    width: 95,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40.0712,
    y: 86.1738,
    width: 95,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09 157.859C120.374 167.035 104.298 172.045 87.7998 172.286C71.3018 172.527 55.0864 167.988 41.1089 159.216L86.5518 86.7347L134.09 157.859Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.09 157.859C120.374 167.035 104.298 172.045 87.7998 172.286C71.3018 172.527 55.0864 167.988 41.1089 159.216L86.5518 86.7347L134.09 157.859Z",
    fill: "#F0EADB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.09 157.859C120.374 167.035 104.298 172.045 87.7998 172.286C71.3018 172.527 55.0864 167.988 41.1089 159.216L86.5518 86.7347L134.09 157.859Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-2-outside-2_5_7287)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 84.6074,
    y: 86.1738,
    width: 84,
    height: 72,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 84.6074,
    y: 86.1738,
    width: 84,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.946 157.644C150.045 146.767 161.964 130.731 167.74 112.175L86.0879 86.7347L133.946 157.644Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.946 157.644C150.045 146.767 161.964 130.731 167.74 112.175L86.0879 86.7347L133.946 157.644Z",
    fill: "#E9ADCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.946 157.644C150.045 146.767 161.964 130.731 167.74 112.175L86.0879 86.7347L133.946 157.644Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-3-outside-3_5_7287)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 84.6074,
    y: 17.1738,
    width: 88,
    height: 96,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 84.6074,
    y: 17.1738,
    width: 88,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.672 112.391C172.974 95.5133 172.917 77.4065 167.508 60.563C162.099 43.7195 151.605 28.9677 137.469 18.3384L86.0879 86.7347L167.672 112.391Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.672 112.391C172.974 95.5133 172.917 77.4065 167.508 60.563C162.099 43.7195 151.605 28.9677 137.469 18.3384L86.0879 86.7347L167.672 112.391Z",
    fill: "#CCA3CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.672 112.391C172.974 95.5133 172.917 77.4065 167.508 60.563C162.099 43.7195 151.605 28.9677 137.469 18.3384L86.0879 86.7347L167.672 112.391Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-4-outside-4_5_7287)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 4.60737,
    y: 16.1738,
    width: 83,
    height: 72,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.60737,
    y: 16.1738,
    width: 83,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8923 16.7482C22.0502 27.1912 10.9128 42.0867 5.09053 59.2805L86.0879 86.7347L36.8923 16.7482Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8923 16.7482C22.0502 27.1912 10.9128 42.0867 5.09053 59.2805L86.0879 86.7347L36.8923 16.7482Z",
    fill: "#F5CC3B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8923 16.7482C22.0502 27.1912 10.9128 42.0867 5.09053 59.2805L86.0879 86.7347L36.8923 16.7482Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-5-outside-5_5_7287)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 36.6074,
    y: 4.17383,
    width: 50,
    height: 83,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 36.6074,
    y: 4.17383,
    width: 50,
    height: 83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1035 16.6001C44.5231 11.4129 52.7188 7.43718 61.3845 4.82125L86.0879 86.7347L37.1035 16.6001Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1035 16.6001C44.5231 11.4129 52.7188 7.43718 61.3845 4.82125L86.0879 86.7347L37.1035 16.6001Z",
    fill: "#BBE6E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1035 16.6001C44.5231 11.4129 52.7188 7.43718 61.3845 4.82125L86.0879 86.7347L37.1035 16.6001Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-6-outside-6_5_7287)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-7_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 60.6074,
    y: 0.173831,
    width: 27,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 60.6074,
    y: 0.173831,
    width: 27,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5986 4.75694C69.6722 2.34276 78.0581 1.13565 86.4845 1.17475L86.0879 86.7347L61.5986 4.75694Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5986 4.75694C69.6722 2.34276 78.0581 1.13565 86.4845 1.17475L86.0879 86.7347L61.5986 4.75694Z",
    fill: "#99439D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5986 4.75694C69.6722 2.34276 78.0581 1.13565 86.4845 1.17475L86.0879 86.7347L61.5986 4.75694Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-7-outside-7_5_7287)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-8_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 81.4516,
    y: -1.08085,
    width: 59.2238,
    height: 95.3316,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 81.4516,
    y: -1.08085,
    width: 59.2238,
    height: 95.3316
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7606 1.27355C105.034 1.78388 122.736 7.76209 137.58 18.4365L84.2112 92.7263L86.7606 1.27355Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7606 1.27355C105.034 1.78388 122.736 7.76209 137.58 18.4365L84.2112 92.7263L86.7606 1.27355Z",
    fill: "#87A1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7606 1.27355C105.034 1.78388 122.736 7.76209 137.58 18.4365L84.2112 92.7263L86.7606 1.27355Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-8-outside-8_5_7287)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-9_5_7287",
    maskUnits: "userSpaceOnUse",
    x: 0.423778,
    y: 57.8594,
    width: 93,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.423778,
    y: 57.8594,
    width: 93,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46623 58.4359C0.939785 72.4766 -0.135258 87.4023 2.33233 101.947L92.7316 86.5959L5.46623 58.4359Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46623 58.4359C0.939785 72.4766 -0.135258 87.4023 2.33233 101.947L92.7316 86.5959L5.46623 58.4359Z",
    fill: "#E25297"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46623 58.4359C0.939785 72.4766 -0.135258 87.4023 2.33233 101.947L92.7316 86.5959L5.46623 58.4359Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-9-outside-9_5_7287)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0943 154.698C123.348 154.698 153.548 124.267 153.548 86.7294C153.548 49.1913 123.348 18.7607 86.0943 18.7607C48.8407 18.7607 18.6406 49.1913 18.6406 86.7294C18.6406 124.267 48.8407 154.698 86.0943 154.698Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1002 151.677C121.699 151.677 150.557 122.598 150.557 86.728C150.557 50.8578 121.699 21.7793 86.1002 21.7793C50.5017 21.7793 21.6435 50.8578 21.6435 86.728C21.6435 122.598 50.5017 151.677 86.1002 151.677Z",
    fill: "#F6F7F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.057 86.728C149.057 121.78 120.859 150.177 86.1002 150.177C51.3409 150.177 23.1435 121.78 23.1435 86.728C23.1435 51.6755 51.3409 23.2793 86.1002 23.2793C120.859 23.2793 149.057 51.6755 149.057 86.728Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.9418,
    cy: 86.599,
    rx: 60.6918,
    ry: 60.6918,
    fill: "#E1E1E1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9634 153.69C123.001 153.69 153.025 123.65 153.025 86.5954C153.025 49.5403 123.001 19.501 85.9634 19.501C48.9259 19.501 18.9013 49.5403 18.9013 86.5954C18.9013 123.65 48.9259 153.69 85.9634 153.69Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWheel);
export default __webpack_public_path__ + "static/media/empty-wheel.2c8e2be6ed432c2e5c987047450379dc.svg";
export { ForwardRef as ReactComponent };